export class GeneralError {
  constructor({ code = 100, message = 'Something went wrong!', data } = {}) {
    this.code = code;
    this.message = message;
    this.data = data;
  }
}
